import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { getLocationMenusThunk } from './thunks';

import { IPagination } from '@ready/dashboardv2api.contracts';
import { IBulkEditMenu } from '@ready/menu.core';

interface State {
  items: IBulkEditMenu[];
  pagination?: IPagination;
  loading: boolean;
}

const initialState: State = {
  loading: true,
  items: [],
};

export const menuLocationSettingsSlice = createSlice({
  name: 'sharedMenus/menus/locationSettings',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<State>) => {
    builder.addCase(getLocationMenusThunk.pending, (state: State) => {
      state.loading = true;
    });
    builder.addCase(getLocationMenusThunk.fulfilled, (state: State, action) => {
      state.loading = false;
      const { items, ...pagination } = action.payload;
      state.items = items;
      state.pagination = pagination;
    });

    builder.addCase(getLocationMenusThunk.rejected, (state: State) => {
      state.loading = false;
    });
  },
});
